// main module
export const SET_SERVER_DATA = "SET_SERVER_DATA";
export const SET_FEATURE_TOGGLES = "SET_APP_CONFIG";
export const SET_AB_TEST_FEATURE_TOGGLES = "SET_AB_TEST_FEATURE_TOGGLES";
export const SET_AB_TEST_HIDDEN_ITEMS = "SET_AB_TEST_HIDDEN_ITEMS";
export const SET_AB_TEST_HIDDEN_CATALOG = "SET_AB_TEST_HIDDEN_CATALOG";
export const SET_AB_TEST_SHOWN_ITEMS_INDEX = "SET_AB_TEST_SHOWN_ITEMS_INDEX";
export const SET_AB_TEST_SHOWN_CATALOG_INDEX = "SET_AB_TEST_SHOWN_CATALOG_INDEX";
export const ADD_GLOBAL_ERROR = "ADD_GLOBAL_ERROR";
export const CLEAR_GLOBAL_ERRORS = "CLEAR_GLOBAL_ERRORS";
export const SET_GLOBAL_INFO_DIALOG = "SET_GLOBAL_INFO_DIALOG";
export const SHOW_DYNAMIC_LOCALIZATION_DISCLAIMER = "SHOW_DYNAMIC_LOCALIZATION_DISCLAIMER";
export const ADD_SELECTION_EXPIRED_MESSAGE = "ADD_SELECTION_EXPIRED_MESSAGE";
export const CLEAR_SELECTION_EXPIRED_MESSAGE = "CLEAR_SELECTION_EXPIRED_MESSAGE";
export const CLEAR_REDIRECT_TO_LOGIN = "CLEAR_REDIRECT_TO_LOGIN";
export const CHANGE_FOOTER_VISIBILITY = "CHANGE_FOOTER_VISIBILITY";
export const RECOMPUTE_PRODUCT_CATALOG_CACHE = "RECOMPUTE_PRODUCT_CATALOG_CACHE";
export const SET_REDIRECT_PATH="SET_REDIRECT_PATH";
export const OPEN_NAV_BAR = "OPEN_NAV_BAR";
export const CLOSE_NAV_BAR = "CLOSE_NAV_BAR";
export const PUSH_NOTIFICATIONS_GRANTED = "PUSH_NOTIFICATIONS_GRANTED";
export const SET_USER_META_FRIEND_INVITE_CODE = "SET_USER_META_FRIEND_INVITE_CODE";
export const SET_DISCOUNT_CAPPED_STATE = "SET_DISCOUNT_CAPPED_STATE";
export const SET_SELECTED_DEAL_ID = "SET_SELECTED_DEAL_ID";
// product main module
export const REFRESH_PRODUCT_CATALOG = "REFRESH_PRODUCT_CATALOG";
export const CHANGE_PRODUCT_CATALOG_ELEMENTS = "CHANGE_PRODUCT_CATALOG_ELEMENTS";
export const SET_ADMIN_TOP_MENU_SHOWN_STATE = "SET_ADMIN_TOP_MENU_SHOWN_STATE";
export const SET_ADMIN_PRODUCT_SNACKBAR_STATE = "SET_ADMIN_PRODUCT_SNACKBAR_STATE";

// ingredients admin/ingredients module
export const REFRESH_INGREDIENTS = "REFRESH_INGREDIENTS";
export const REFRESH_INGREDIENTS_END_OF_READING = "REFRESH_INGREDIENTS_END_OF_READING";
export const ADMIN_SET_SELECTED_INGREDIENT = "ADMIN_SET_SELECTED_INGREDIENT";
export const ADMIN_ALL_INGREDIENTS_READ = "ADMIN_ALL_INGREDIENTS_READ";
export const REFRESH_PRODUCTS_INGREDIENTS = "REFRESH_PRODUCTS_INGREDIENTS";
export const CACHE_ALL_PRODUCTS_INGREDIENTS = "CACHE_ALL_PRODUCTS_INGREDIENTS";
export const SET_INGREDIENT_EDIT_STATE = "SET_INGREDIENT_EDIT_STATE";


// shops admin/shops module
export const REFRESH_SHOPS = "REFRESH_SHOPS";
export const SET_SHOPS = "SET_SHOPS";

// food categories admin/foodCategories module
export const REFRESH_FOOD_CATEGORIES = "REFRESH_FOOD_CATEGORIES";
export const REFRESH_FOOD_CATEGORY = "REFRESH_FOOD_CATEGORY";

// main shop module
export const SET_GLOBAL_SELECTED_SHOP = "SET_GLOBAL_SELECTED_SHOP";
export const UNSET_GLOBAL_SELECTED_SHOP = "UNSET_GLOBAL_SELECTED_SHOP";
export const SET_REDIRECT_URL = "SET_REDIRECT_URL";
export const SET_GLOBAL_SELECTED_SHOP_REFRESH_TOKEN = "SET_GLOBAL_SELECTED_SHOP_REFRESH_TOKEN";

// user
export const SET_USER_IDP_TOKEN = "SET_USER_IDP_TOKEN";
export const SET_USER_REFRESH_TOKEN = "SET_USER_REFRESH_TOKEN";
export const RESET_USER_ACCESS_TOKEN_USING_REFRESH_TOKEN = "RESET_USER_ACCESS_TOKEN_USING_REFRESH_TOKEN";
export const REMOVE_USER_IDP_TOKEN = "REMOVE_USER_IDP_TOKEN";
export const SET_REFRESHING_STATE = "SET_REFRESHING_STATE";
export const SET_REFRESHING_CALL = "SET_REFRESHING_CALL";
export const SET_IDP_ACTION = "SET_IDP_ACTION";
export const SET_SAVINGS_STATISTICS_VALUES = "SET_SAVINGS_STATISTICS_VALUES";
export const SET_SUBSCRIPTION_EXISTS_DATA = "SET_SUBSCRIPTION_EXISTS_DATA";
export const SET_RECURRING_PAYMENT_DETAILS = "SET_RECURRING_PAYMENT_DETAILS";
export const SET_UNIQUE_SESSION_ID = "SET_UNIQUE_SESSION_ID";
export const GET_TEST_USERS = "GET_TEST_USERS";
export const SET_TEST_USERS = "SET_TEST_USERS";
export const FETCH_USER_CRM_VOUCHERS_AND_MILESTONE_REWARDS = "FETCH_USER_CRM_VOUCHERS_AND_MILESTONE_REWARDS";
export const SET_USER_CRM_VOUCHERS_AND_MILESTONE_REWARDS = "SET_USER_CRM_VOUCHERS_AND_MILESTONE_REWARDS";

// cart module
export const ADD_TO_CART = "ADD_TO_CART";
export const ADD_TO_CART_BULK = "ADD_TO_CART_BULK";
export const REMOVE_FROM_CART_BULK = "REMOVE_FROM_CART_BULK";
export const ADD_TO_CART_SINGLE_ITEM = "ADD_TO_CART_SINGLE_ITEM";
export const CHECKOUT_RESET_WITH_LAST_UPDATE_TIME = "CHECKOUT_RESET_WITH_LAST_UPDATE_TIME";
export const ADD_PRODUCT_SELECTION_TO_CART = "ADD_PRODUCT_SELECTION_TO_CART";
export const UPDATE_CART_PRODUCT_SELECTIONS_BY_PRODUCT_ID = "UPDATE_CART_PRODUCT_SELECTIONS_BY_PRODUCT_ID";
export const CART_INCREASE_STEP = "CART_INCREASE_STEP";
export const CART_DECREASE_STEP = "CART_DECREASE_STEP";
export const CART_INCREASE_STEP_GT3 = "CART_INCREASE_STEP_GT3";
export const CART_DECREASE_STEP_GT3 = "CART_DECREASE_STEP_GT3";
export const CART_RESET_STEP_GT3 = "CART_RESET_STEP_GT3";
export const CART_EMPTY_ALL = "CART_EMPTY";
export const PURGE_CART = "PURGE_CART";
export const CART_SUBMIT_USER_DATA = "CART_SUBMIT_USER_DATA";
export const CART_SET_SHOP_DATA = "CART_SET_SHOP_DATA";
export const CART_INITIALIZE_PAYMENT = "CART_INITIALIZE_PAYMENT";
export const CART_INITIALIZE_TERMINAL_PAYMENT = "CART_INITIALIZE_TERMINAL_PAYMENT";
export const CART_SAVE_PAYMENT = "CART_SAVE_PAYMENT";
export const CART_GET_ORDER_NUMBER_BY_PAYMENT = "CART_GET_ORDER_NUMBER_BY_PAYMENT";
export const CART_SUBMIT_ORDER = "CART_SUBMIT_ORDER";
export const CART_SET_PICKUP_DATA = "CART_SET_PICKUP_DATA";
export const FETCH_AND_CACHE_SHOPS = "FETCH_AND_CACHE_SHOPS";
export const FETCH_AND_CACHE_PICKUP_RULES = "FETCH_AND_CACHE_PICKUP_RULES";
export const MUST_BE_HEATED = "MUST_BE_HEATED";
export const CHECKOUT_ORDER_SENT = "CHECKOUT_ORDER_SENT";
export const FACEBOOK_PIXEL_PURCHASE = "FACEBOOK_PIXEL_PURCHASE";
export const ADD_VOUCHER_TO_ORDER = "ADD_VOUCHER_TO_ORDER";
export const REMOVE_VOUCHER_FROM_ORDER = "REMOVE_VOUCHER_FROM_ORDER";
export const CLEAR_VOUCHERS_FROM_ORDER = "CLEAR_VOUCHERS_FROM_ORDER";
export const SET_VOUCHER_VIRTUAL_ORDER_ID = "SET_VOUCHER_VIRTUAL_ORDER_ID";
export const CHECKOUT_RESET = "CHECKOUT_RESET";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const REMOVE_FROM_CART_SUB_PRODUCT = "REMOVE_FROM_CART_SUB_PRODUCT";
export const REMOVE_FROM_CART_BY_PRODUCT_SELECTION_ID = "REMOVE_FROM_CART_BY_PRODUCT_SELECTION_ID";
export const REMOVE_FROM_CART_WITHOUT_CHECKOUT_RESET = "REMOVE_FROM_CART_WITHOUT_CHECKOUT_RESET";
export const SET_CACHED_SHOPS = "SET_CACHED_SHOPS";
export const SET_CACHED_PICKUP_RULES = "SET_CACHED_PICKUP_RULES";
export const UPDATE_CART_QUANTITY = "UPDATE_CART_QUANTITY";
export const UPDATE_CART_QUANTITY_BY_ID = "UPDATE_CART_QUANTITY_BY_ID";
export const UPDATE_CART_NAME = "UPDATE_CART_NAME";
export const UPDATE_CART_SUBORDERLINES = "UPDATE_CART_SUBORDERLINES";
export const UPDATE_SPECIAL_NOTES = "UPDATE_SPECIAL_NOTES";
export const UPDATE_USER_CONSENT = "UPDATE_USER_CONSENT";
export const SET_CART_ORDER_ID = "SET_CART_ORDER_ID";
export const SET_CART_ORDER_TAGS = "SET_CART_ORDER_TAGS";
export const RECALCULATE_SUBSCRIPTION_SET_CART_ORDER_TAGS = "RECALCULATE_SUBSCRIPTION_SET_CART_ORDER_TAGS";
export const SET_DISCOUNT_CODE = "SET_DISCOUNT_CODE";
export const REMOVE_DISCOUNT_CODE = "REMOVE_DISCOUNT_CODE";
export const SET_SUNSET_POINTS = "SET_SUNSET_POINTS";
export const SET_TENANT_SPECIFIC_DATA = "SET_TENANT_SPECIFIC_DATA";
export const DELETE_TENANT_SPECIFIC_DATA = "DELETE_TENANT_SPECIFIC_DATA";
export const REMOVE_FROM_TENANT_SPECIFIC_DATA = "REMOVE_FROM_TENANT_SPECIFIC_DATA";
export const SET_ASAP_PICKUP = "SET_ASAP_PICKUP";
export const SET_LAST_UPDATE_TIME = "SET_LAST_UPDATE_TIME";
export const GATHER_EVALUATION_TAG_DATA="GATHER_EVALUATION_TAG_DATA";
export const STORE_TARGET_GROUP_DATA="STORE_TARGET_GROUP_DATA";
export const GATHER_TARGET_GROUP_DATA="GATHER_TARGET_GROUP_DATA";
export const ADD_ORDER_TAGS_BASED_ON_PICKUP_OPTION="ADD_ORDER_TAGS_BASED_ON_PICKUP_OPTION";
export const ADD_TEMPORARY_ADDRESS_TO_PERMANENT_ADDRESS="ADD_TEMPORARY_ADDRESS_TO_PERMANENT_ADDRESS";
export const ADD_DELIVERY_TIME="ADD_DELIVERY_TIME";
export const ADD_TEMPORARY_ADDRESS="ADD_TEMPORARY_ADDRESS";
export const ADD_DELIVERY_ADDRESS_AND_FLOOR = "ADD_DELIVERY_ADDRESS_AND_FLOOR";
export const ADD_FAVORITE_RESTAURANT = "ADD_FAVORITE_RESTAURANT";
export const DELETE_FAVORITE_RESTAURANT = "DELETE_FAVORITE_RESTAURANT";
export const ADD_FAVORITE_PRODUCT = "ADD_FAVORITE_PRODUCT";
export const REMOVE_FAVORITE_PRODUCT = "REMOVE_FAVORITE_PRODUCT";
export const SET_GROUP_ORDER = "SET_GROUP_ORDER";
export const GROUP_ORDER_IS_USER_OWNER = "GROUP_ORDER_IS_USER_OWNER";
export const UPDATE_GROUP_ORDER_FRIENDS_ORDERS = "UPDATE_GROUP_ORDER_FRIENDS_ORDERS";
export const FILTER_ONLY_OWNERS_PRODUCT_SELECTIONS = "FILTER_ONLY_OWNERS_PRODUCT_SELECTIONS";
export const RESET_GROUP_ORDER_STATE = "RESET_GROUP_ORDER_STATE";
export const ADD_FRIEND_INVITE_CODE_TO_ORDER = "ADD_FRIEND_INVITE_CODE_TO_ORDER";
export const SET_VOUCHER_PRODUCT_ADD_TO_CART = "SET_VOUCHER_PRODUCT_ADD_TO_CART";
export const SET_USER_CRM_USED_VOUCHERS = "SET_USER_CRM_USED_VOUCHERS";

// cart change order
export const ENABLE_ORDER_EDIT_MODE = "ENABLE_ORDER_EDIT_MODE";
export const DISABLE_ORDER_EDIT_MODE = "DISABLE_ORDER_EDIT_MODE";
export const SAVE_ORDER_CHANGE = "SAVE_ORDER_CHANGE";
export const CANCEL_ORDER_CHANGE = "CANCEL_ORDER_CHANGE";

// userData module
export const SET_EMPLOYEE_DISCOUNT_TOKEN = "SET_EMPLOYEE_DISCOUNT_TOKEN";
export const SET_RETROACTIVE_POINTS_ASSIGNMENT_PENDING_ORDER_ID = "SET_RETROACTIVE_POINTS_ASSIGNMENT_PENDING_ORDER_ID";
export const SET_ESTIMATED_POINTS = "SET_ESTIMATED_POINTS";
export const SET_CURRENT_CATALOG_PAGE = "SET_CURRENT_CATALOG_PAGE";
export const SET_CURRENT_PRODUCT = "SET_CURRENT_PRODUCT";
export const SHOW_EMPLOYEE_DISCOUNT_SUCCESS_MESSAGE = "SHOW_EMPLOYEE_DISCOUNT_SUCCESS_MESSAGE";
export const SET_EXPERIMENT_ID = "SET_EXPERIMENT_ID";
export const SET_RECOMMENDED_PRODUCTS = "SET_RECOMMENDED_PRODUCTS";
export const SET_RECOMMENDED_PRODUCTS_FOR_CATALOG_PAGE = "SET_RECOMMENDED_PRODUCTS_FOR_CATALOG_PAGE";
export const SET_PICKED_RECOMMENDED_PRODUCTS = "SET_PICKED_RECOMMENDED_PRODUCTS";
export const USER_DATA_SET = "USER_DATA_SET";
export const PRODUCT_CATEGORY_ID = "PRODUCT_CATEGORY_ID";
export const CART_USER_DATA_SET = "CART_USER_DATA_SET";
export const REMEMBER_LOGIN_HISTORY = "REMEMBER_LOGIN_HISTORY";
export const FIRST_LOGIN_SET = "FIRST_LOGIN_SET";
export const SET_AUTH_FLOW_TRACKING = "SET_AUTH_FLOW_TRACKING";
export const REMOVE_USER_DATA = "REMOVE_USER_DATA";
export const USER_DATA_PERSIST_TOGGLE = "USER_DATA_PERSIST_TOGGLE";
export const ENABLE_USER_EDIT_MODE = "ENABLE_USER_EDIT_MODE";
export const DISABLE_USER_EDIT_MODE = "DISABLE_USER_EDIT_MODE";
export const GATHER_USER_DATA="GATHER_USER_DATA";
export const SET_FAVORITE_RESTAURANTS = "SET_FAVORITE_RESTAURANTS";
export const SET_FAVORITE_PRODUCTS = "SET_FAVORITE_PRODUCTS";
export const CUSTOMER_FETCHING_SUCCESS="CUSTOMER_FETCHING_SUCCESS";
export const CUSTOMER_INITIALIZATION_REQUIRED="CUSTOMER_INITIALIZATION_REQUIRED";
export const SET_SUBSCRIPTION_FLOW="SET_SUBSCRIPTION_FLOW";
export const FOCUS_SUBSCRIPTION_TERMS="FOCUS_SUBSCRIPTION_TERMS";
export const SUBMIT_SUBSCRIPTION_TERMS="SUBMIT_SUBSCRIPTION_TERMS";
export const SET_SUBSCRIPTION_DATA="SET_SUBSCRIPTION_DATA";
export const SET_USER_CVR_NUMBER="SET_USER_CVR_NUMBER";
export const SHOW_SUBSCRIPTION_SUB_FLOW="SHOW_SUBSCRIPTION_SUB_FLOW";
export const SHOW_USER_ORDERS_SUB_FLOW="SHOW_USER_ORDERS_SUB_FLOW";
export const SHOW_FEEDBACK_SUB_FLOW="SHOW_FEEDBACK_SUB_FLOW";
export const SHOW_USER_DATA_SUB_FLOW="SHOW_USER_DATA_SUB_FLOW";
export const FEEDBACK_LEFT="FEEDBACK_LEFT";
export const SUBSCRIPTION_PAYMENT_METHOD="SUBSCRIPTION_PAYMENT_METHOD";
export const GET_USER_ORDERS="GET_USER_ORDERS";
export const SET_USER_ORDERS="SET_USER_ORDERS";
export const GET_LAST_ORDER = "GET_LAST_ORDER";
export const SET_LAST_ORDER = "SET_LAST_ORDER";
export const SET_HISTORY_PRODUCTS = "SET_HISTORY_PRODUCTS";
export const SHOW_DEV_SUPPORT = "SHOW_DEV_SUPPORT";

// user module
export const PERSON_DATA_SET = "PERSON_DATA_SET";
export const PERSON_DATA_CLEAR = "PERSON_DATA_CLEAR";
export const PERSON_DATA_UPDATE = "PERSON_DATA_UPDATE";
export const PERSON_DELETE_ACCOUNT = "PERSON_DELETE_ACCOUNT";
export const PERSON_EXISTS = "PERSON_EXISTS";

// admin module
export const ADMIN_SET_JWT_TOKEN = "ADMIN_SET_JWT_TOKEN";
export const ADMIN_REFRESH_AD_LOGIN_STATE = "ADMIN_REFRESH_AD_LOGIN_STATE";
export const ADMIN_REFRESH_GOOGLE_AUTH_LOGIN_STATE = "ADMIN_REFRESH_GOOGLE_AUTH_LOGIN_STATE";
export const ADMIN_GOOGLE_AUTH_STATE = "ADMIN_GOOGLE_AUTH_STATE";
export const ADMIN_AD_AUTH_STATE = "ADMIN_AD_AUTH_STATE";
export const ADMIN_REMOVE_JWT_TOKEN = "ADMIN_REMOVE_JWT_TOKEN";
export const ADMIN_SET_ADMIN_DETAILS = "ADMIN_SET_ADMIN_DETAILS";
export const ADMIN_ORDER_SET_DATE_FILTER = "ADMIN_ORDER_SET_DATE_FILTER";
export const ADMIN_ORDER_SET_ORDERS = "ADMIN_ORDER_SET_ORDERS";
export const ADMIN_ORDER_TOTAL_PENDING_ORDERS = "ADMIN_ORDER_TOTAL_PENDING_ORDERS";
export const ADMIN_SET_REDIRECT_URL = "ADMIN_SET_REDIRECT_URL";
export const ADMIN_ORDER_CONFIRM = "ADMIN_ORDER_CONFIRM";
export const ADMIN_ORDER_REJECT = "ADMIN_ORDER_REJECT";
export const ADMIN_ORDER_REMOVE = "ADMIN_ORDER_REMOVE";
export const ADMIN_ORDER_UPDATE = "ADMIN_ORDER_UPDATE";
export const ADMIN_SELECT_DEPARTMENT = "ADMIN_SELECT_DEPARTMENT";
export const ADMIN_UPSERT_ORDER = "ADMIN_UPSERT_ORDER";
export const ADMIN_UPDATE_NEW_ORDER_FLAG = "ADMIN_UPDATE_NEW_ORDER_FLAG";
export const ADMIN_HOME_PAGE_LINKS = "ADMIN_HOME_PAGE_LINKS";
export const ADMIN_SET_NAV_MENU_ITEMS = "ADMIN_SET_NAV_MENU_ITEMS";
export const ADMIN_SET_JWT_TOKEN2 = "ADMIN_SET_JWT_TOKEN2";

// admin order form
export const ADMIN_ORDER_FORM_EDIT_PRODUCT_SELECTION = "ADMIN_ORDER_FORM_EDIT_PRODUCT_SELECTION";
export const ADMIN_ORDER_FORM_EDIT_ORDER_DATA = "ADMIN_ORDER_FORM_EDIT_ORDER_DATA";
export const ADMIN_ORDER_FORM_RESET_ORDER_DATA = "ADMIN_ORDER_FORM_RESET_ORDER_DATA";
export const ADMIN_ORDER_BULK_FORM_NEW_ORDER_ADD = "ADMIN_ORDER_BULK_FORM_NEW_ORDER_ADD";
export const ADMIN_ORDER_BULK_FORM_RESET_ORDER_DATA = "ADMIN_ORDER_BULK_FORM_RESET_ORDER_DATA";
export const ADMIN_ORDER_BULK_FORM_REMOVE_ORDER_DATA = "ADMIN_ORDER_BULK_FORM_REMOVE_ORDER_DATA";
export const ADMIN_ORDER_BULK_FORM_DUPLICATE_ORDER_DATA = "ADMIN_ORDER_BULK_FORM_DUPLICATE_ORDER_DATA";
export const ADMIN_ORDER_BULK_FORM_EDIT_ORDER_DATA = "ADMIN_ORDER_BULK_FORM_EDIT_ORDER_DATA";

// admin products
export const ADMIN_SET_SELECTED_PRODUCT = "ADMIN_SET_SELECTED_PRODUCT";
export const ADMIN_SET_PRODUCT_EDITING_STATE = "ADMIN_SET_PRODUCT_EDITING_STATE";
export const ADMIN_SET_PRODUCT_MASS_EDITING_STATE = "ADMIN_SET_PRODUCT_MASS_EDITING_STATE";
export const ADMIN_SET_SELECTED_VERSION = "ADMIN_SET_SELECTED_VERSION";

// admin catalogs
export const ADMIN_SET_CATALOG_EDITING_STATE = "ADMIN_SET_CATALOG_EDITING_STATE";
export const ADMIN_SET_SELECTED_CATALOG = "ADMIN_SET_SELECTED_CATALOG";
export const ADMIN_SET_SELECTED_CATALOG_ID = "ADMIN_SET_SELECTED_CATALOG_ID";
export const ADMIN_SET_TEMP_CATALOG = "ADMIN_SET_TEMP_CATALOG";
export const ADMIN_SET_CATALOG_MAIN_LOADING = "ADMIN_SET_CATALOG_MAIN_LOADING";
export const ADMIN_SET_PRODUCT_CATALOG_BY_VERSIONS = "ADMIN_SET_PRODUCT_CATALOG_BY_VERSIONS";

export const ADMIN_INIT_GBO_APP = "ADMIN_INIT_GBO_APP";

// order control panel
export const UPDATE_ORDER_CONTROL_PANEL_DATA = "UPDATE_ORDER_CONTROL_PANEL_DATA";


// product module
export const UPDATE_CONFIGURATION_STEP = "UPDATE_CONFIGURATION_STEP";
export const RESET_CONFIGURATION_STEP = "RESET_CONFIGURATION_STEP";
export const INCREASE_CONFIGURATION_STEP = "INCREASE_CONFIGURATION_STEP";
export const DECREASE_CONFIGURATION_STEP = "DECREASE_CONFIGURATION_STEP";

//localization
export const ADD_CATALOG = "ADD_CATALOG";
export const CLEAR_LOCALIZATION_CACHE = "CLEAR_LOCALIZATION_CACHE";
export const SET_LAST_LOCALE = "SET_LAST_LOCALE";
export const SET_LAST_LOCALE_ADMIN = "SET_LAST_LOCALE_ADMIN";
export const ALL_TENANT_LANGUAGES = "ALL_TENANT_LANGUAGES";
export const ADD_LANGUAGE = "ADD_LANGUAGE";
export const ADD_LANGUAGES = "ADD_LANGUAGES";
export const REMOVE_CATALOG = "REMOVE_CATALOG";
export const REMOVE_LANGUAGE = "REMOVE_LANGUAGE";
export const SET_DYNAMIC_CATALOG = "SET_DYNAMIC_CATALOG";
export const TENANT_GROUP_LANGUAGES = "TENANT_GROUP_LANGUAGES";

// fraud protection
export const SET_FRAUD_PROTECTION = "SET_FRAUD_PROTECTION";
export const HIDE_FRAUD_PROTECTION_MODAL = "HIDE_FRAUD_PROTECTION_MODAL";
export const MAXIMUM_NUMBER_OF_DEVICES_REACHING = "MAXIMUM_NUMBER_OF_DEVICES_REACHING";

// device data module
export const SET_DEVICE_INFO = "SET_DEVICE_INFO";
export const SET_DEVICE_DATA = "SET_DEVICE_DATA";
export const REMOVE_DEVICE_DATA = "REMOVE_DEVICE_DATA";
export const FCM_TOKEN = "FCM_TOKEN";

// Ui module
export const HIGHLIGHT_GROUPS_WITH_MISSING_SELECTION = "HIGHLIGHT_GROUPS_WITH_MISSING_SELECTION";

// product selections
export const UPDATE_PRODUCT_SELECTIONS="UPDATE_PRODUCT_SELECTIONS";
export const SAVE_PRODUCT="SAVE_PRODUCT";
// upsell rules data module
export const SET_UPSELL_RULES = "SET_UPSELL_RULES";
export const REMOVE_UPSELL_RULES = "REMOVE_UPSELL_RULES";
export const SET_UPSELL_MODAL_STATE = "SET_UPSELL_MODAL_STATE";
export const SET_MYSTERY_BOX_MODAL_STATE = "SET_MYSTERY_BOX_MODAL_STATE";
export const SET_REORDER_STATE = "SET_REORDER_STATE";
export const SET_PREVIOUS_ORDER_TOTAL = "SET_PREVIOUS_ORDER_TOTAL";
export const SET_CROSS_SELL_DISPLAYED_ON_CATALOG_PAGE = "SET_CROSS_SELL_DISPLAYED_ON_CATALOG_PAGE";
export const CLEAR_ALL_CROSS_SELL_DISPLAYED_ON_CATALOG_PAGE = "CLEAR_ALL_CROSS_SELL_DISPLAYED_ON_CATALOG_PAGE";
export const CROSS_SELL_PRODUCT_FOR_ADD_TO_CART = "CROSS_SELL_PRODUCT_FOR_ADD_TO_CART";
// terms and conditions data module
export const SET_TERMS_AND_CONDITIONS = "SET_TERMS_AND_CONDITIONS";

export const SET_QR_CODE_TABLE_SERVING_DATA = "SET_QR_CODE_TABLE_SERVING_DATA";

export const FETCH_PRODUCT_TAGS = "FETCH_PRODUCT_TAGS";
export const SET_PRODUCT_TAGS_DATA = "SET_PRODUCT_TAGS_DATA";
export const SET_PRODUCT_ASSIGNED_TAGS_DATA = "SET_PRODUCT_ASSIGNED_TAGS_DATA";

export const FETCH_UPSELL_RULES = "FETCH_UPSELL_RULES";
export const SET_UPSELL_RULES_DATA = "SET_UPSELL_RULES_DATA";

export const FETCH_PRICE_RULES = "FETCH_PRICE_RULES";
export const SET_PRICE_RULES_DATA = "SET_PRICE_RULES_DATA";

export const FETCH_RCM_CATALOG_PAGES_SORTING = "FETCH_RCM_CATALOG_PAGES_SORTING";
export const SET_RCM_CATALOG_PAGES_SORTING_DATA = "SET_RCM_CATALOG_PAGES_SORTING_DATA";
export const SET_SUBSCRIPTION_DETAILS_IS_ALREADY_DOWNGRADED = "SET_SUBSCRIPTION_DETAILS_IS_ALREADY_DOWNGRADED";
export const FETCH_RCM_PRODUCT_BADGES = "FETCH_RCM_PRODUCT_BADGES";
export const SET_RCM_PRODUCT_BADGES = "SET_RCM_PRODUCT_BADGES";
export const SET_RCM_PRODUCT_BADGES_RECOMMENDATIONS = "SET_RCM_PRODUCT_BADGES_RECOMMENDATIONS";
export const SET_RCM_PRODUCT_BADGES_PICKS = "SET_RCM_PRODUCT_BADGES_PICKS";
export const SET_SUBSCRIPTION_UPGRADE_PLAN_NAME = "SET_SUBSCRIPTION_UPGRADE_PLAN_NAME";
export const SET_SUBSCRIPTION_UPGRADE_PACKAGE = "SET_SUBSCRIPTION_UPGRADE_PACKAGE";
export const SET_MEMBERSHIP_PLANS = "SET_MEMBERSHIP_PLANS";
export const SET_SUBSCRIPTION_DOWNGRADE_PLAN_NAME = "SET_SUBSCRIPTION_DOWNGRADE_PLAN_NAME";

// GIGYA SDK integration
// new approach
export const INIT_GIGYA_SESSION = "INIT_GIGYA_SESSION";
export const SET_GIGYA_READY = "SET_GIGYA_READY";
export const SET_GIGYA_ERROR = "SET_GIGYA_ERROR";
export const FETCH_GIGYA_ACCOUNT_INFO = "FETCH_GIGYA_ACCOUNT_INFO";
export const SET_GIGYA_LOADING = "SET_GIGYA_ACCOUNT_LOADING";
export const SET_GIGYA_ACCOUNT_INFO = "SET_GIGYA_ACCOUNT_INFO";
export const OBTAIN_NEW_JWT = "OBTAIN_NEW_JWT";
